@if (singleActions.length > 0) {
  <button
    mat-icon-button
    type="button"
    class="operations-menu-button tw-w-[32px] tw-h-[32px] hover:tw-bg-gray-200 tw-rounded-md"
    [class.menu-is-open]="matMenuTrigger?.menuOpen ?? false"
    [matMenuTriggerFor]="menu"
    #matMenuTrigger="matMenuTrigger"
    (click)="$event.stopPropagation()"
    [id]="id + '-button'"
    aria-label="Operations menu"
  >
    <div class="tw-flex tw-items-center tw-justify-center">
      <mat-icon
        svgIcon="more-vertical"
        class="tw-cursor-pointer tw-rotate-90 tw-text-gray-800"
      />
    </div>
  </button>
}

<mat-menu
  #menu="matMenu"
  classList="operations-menu"
  aria-label="Operations menu"
>
  @for (operation of singleActions; track operation.name) {
    @if (operation.isDelete || operation.danger) {
      <mat-divider />
    }
    <button
      mat-menu-item
      type="button"
      [class.tw-text-red-700]="operation.isDelete || operation.danger"
      (click)="handleClick(operation.name)"
      [id]="'action' + operation.name.split(' ').join('')"
      class="operations-menu-item"
      [ngClass]="{ 'rise-admin-only': operation.requireRole === 'sa' }"
    >
      <mat-icon class="extra-thin small" svgIcon="{{ operation.icon }}" />
      <span>{{ operation.name }}</span>
    </button>
  }
</mat-menu>
